import { useEffect, useState } from "react";

import { FormDialog, TextField } from "@/components";

/**
 * 이름을 바꾸는 작은 창. 내 이름과 상대 별칭이 같은 모양이라 하나로 쓴다.
 *
 * 상대 별칭은 **비울 수 있다**(원래 이름으로 돌아간다). 내 이름은 비울 수 없다 —
 * 목록과 아바타가 이름으로 서기 때문에 비면 빈칸이 남는다. 그 차이를
 * `allowEmpty`로 가른다.
 */

type RenameDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  label: string;
  /** 처음에 채워둘 값. 별칭이 없으면 원래 이름을 넣어준다. */
  initialValue: string;
  placeholder?: string;
  /** 비우면 지운다는 뜻인가. 상대 별칭은 true, 내 이름은 false. */
  allowEmpty?: boolean;
  pending?: boolean;
  onSubmit: (value: string) => void;
};

export function RenameDialog({
  open,
  onOpenChange,
  title,
  description,
  label,
  initialValue,
  placeholder,
  allowEmpty = false,
  pending = false,
  onSubmit,
}: RenameDialogProps) {
  const [value, setValue] = useState(initialValue);

  // 창을 다시 열 때마다 지금 값에서 시작해야 한다. 닫으면서 지우면 열리는
  // 순간 빈칸이 스쳐 보인다.
  useEffect(() => {
    if (open) setValue(initialValue);
  }, [open, initialValue]);

  const trimmed = value.trim();

  return (
    <FormDialog
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={description}
      submitLabel="바꾸기"
      pendingLabel="바꾸는 중…"
      pending={pending}
      canSubmit={allowEmpty || trimmed.length > 0}
      onSubmit={() => onSubmit(trimmed)}
    >
      <TextField
        label={label}
        value={value}
        placeholder={placeholder}
        maxLength={40}
        autoFocus
        onChange={(event) => setValue(event.target.value)}
      />
    </FormDialog>
  );
}
